import { handleDemoApiRequest } from './demoApi'
import { isDemoMode } from './demoSession'

const request = async (url, options = {}) => {
  if (isDemoMode()) {
    const demoResponse = await handleDemoApiRequest(url, options)
    if (demoResponse !== null) return demoResponse
  }

  const response = await fetch(url, { credentials: 'include', ...options })
  let data = null
  try {
    data = await response.json()
  } catch {
    data = null
  }

  if (!response.ok) {
    const error = new Error(data?.message || `HTTP ${response.status}`)
    error.status = response.status
    error.payload = data
    throw error
  }

  return data
}

export const materialCalculatorApi = {
  status: () => request('/api/material-calculator/status'),
  listProjects: () => request('/api/material-calculator/projects'),
  getProject: (projectId) => request(`/api/material-calculator/projects/${projectId}`),
  createProject: (payload) => request('/api/material-calculator/projects', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }),
  duplicateProject: (projectId) => request(`/api/material-calculator/projects/${projectId}/duplicate`, { method: 'POST' }),
  deleteProject: (projectId) => request(`/api/material-calculator/projects/${projectId}`, { method: 'DELETE' }),
  listInputs: (projectId) => request(`/api/material-calculator/projects/${projectId}/inputs`),
  saveInput: (projectId, sectionKey, inputJson) => request(`/api/material-calculator/projects/${projectId}/inputs`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sectionKey, inputJson }),
  }),
  runTakeoff: (projectId, payload) => request(`/api/material-calculator/projects/${projectId}/takeoff`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }),
  listRuns: (projectId) => request(`/api/material-calculator/projects/${projectId}/runs`),
  listRulesets: () => request('/api/material-calculator/rulesets'),
  getRuleset: (rulesetId) => request(`/api/material-calculator/rulesets/${rulesetId}`),
  overrideParameter: (rulesetId, paramKey, payload) => request(`/api/material-calculator/rulesets/${rulesetId}/parameters/${encodeURIComponent(paramKey)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }),
  listCatalog: () => request('/api/material-calculator/catalog'),
}
